import { apiEndPoint } from "./endPoint";

export const assistantContinueConversation = async (
  token: string,
  message: string,
  threadId: string,
  assistantId?: string
) => {
  let url = `${apiEndPoint}/assistantContinueConversation`;

  if (assistantId) {
    url = url + `/${assistantId}`;
  }

  const data = {
    message: message,
    threadId: threadId,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      //   const responseMessage: messageData = {
      //     role: "assistant",
      //     content: responseData.message,
      //   };

      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
